var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2,0h-10C3.6,0,3.1,0.2,2.7,0.6l-2,2C0.2,3.1,0,3.6,0,4.2v10.1c0,1,0.8,1.8,1.8,1.8h12.5 c1,0,1.8-0.8,1.8-1.8V1.8C16,0.8,15.2,0,14.2,0z M4.9,1h6.3v3.4c0,0.5-0.4,0.8-0.8,0.8H5.7c-0.5,0-0.8-0.4-0.8-0.8V1z M11.9,15H4.1 v-3.9c0-0.5,0.4-0.8,0.8-0.8h6.2c0.5,0,0.8,0.4,0.8,0.8V15z M15,14.2c0,0.4-0.4,0.8-0.8,0.8h-1.4v-3.9c0-1-0.8-1.8-1.8-1.8H4.9 c-1,0-1.8,0.8-1.8,1.8V15H1.8C1.3,15,1,14.7,1,14.2v-10c0-0.3,0.1-0.6,0.4-0.9l2-2C3.5,1.2,3.7,1.1,3.9,1v3.3c0,1,0.8,1.8,1.8,1.8 h4.6c1,0,1.8-0.8,1.8-1.8V1h2.1C14.7,1,15,1.3,15,1.8V14.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.d3c23ecb168cfb83df5f27fec88ed16f.svg";
export { ForwardRef as ReactComponent };